<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />
        <div class="card" v-if="orderFetched">
          <div class="card-body">
            <div class="card-sales-split">
              <div>
                <span class="d-block">
                  <b class="fw-bold">Order Reference : </b>{{ order.reference }}
                </span>
                <span class="d-block" v-if="order.requested_by">
                  <b class="fw-bold">Requested By : </b
                  >{{ order.requested_by.name }}
                </span>
              </div>
              <ul style="align-items: center">
                <li>
                  <a href="javascript:void(0);" @click="exportToPdf"
                    ><img src="../../../assets/img/icons/printer.svg" alt="img"
                  /></a>
                </li>
                <li>
                  <a href="javascript:void(0);" @click="exportToPosPdf">
                    <img
                      style="width: 30px"
                      src="../../../assets/img/icons/pos.svg"
                      alt="img"
                  /></a>
                </li>
              </ul>
            </div>
            <div id="order-detail">
              <div
                class="invoice-box table-height"
                style="
                  max-width: 1600px;
                  width: 100%;
                  overflow: auto;
                  margin: 15px auto;
                  padding: 0;
                  font-size: 14px;
                  line-height: 24px;
                  color: #555;
                "
              >
                <table
                  cellpadding="0"
                  cellspacing="0"
                  style="width: 100%; line-height: inherit; text-align: left"
                >
                  <tbody>
                    <tr class="top">
                      <td colspan="6" style="padding: 5px; vertical-align: top">
                        <table
                          style="
                            width: 100%;
                            line-height: inherit;
                            text-align: left;
                          "
                        >
                          <tbody>
                            <tr>
                              <td
                                style="
                                  padding: 5px;
                                  vertical-align: top;
                                  text-align: left;
                                  padding-bottom: 20px;
                                "
                              >
                                <font
                                  style="
                                    vertical-align: inherit;
                                    margin-bottom: 25px;
                                  "
                                >
                                  <font
                                    style="
                                      vertical-align: inherit;
                                      font-size: 14px;
                                      color: #7367f0;
                                      font-weight: 600;
                                      line-height: 35px;
                                    "
                                    >Customer Info</font
                                  > </font
                                ><br />
                                <font style="vertical-align: inherit">
                                  <font
                                    style="
                                      vertical-align: inherit;
                                      font-size: 14px;
                                      color: #000;
                                      font-weight: 400;
                                    "
                                  >
                                    {{ order.user.name }}</font
                                  > </font
                                ><br />
                                <font style="vertical-align: inherit">
                                  <font
                                    style="
                                      vertical-align: inherit;
                                      font-size: 14px;
                                      color: #000;
                                      font-weight: 400;
                                    "
                                  >
                                    {{ order.user.email }}</font
                                  > </font
                                ><br />
                                <font style="vertical-align: inherit">
                                  <font
                                    style="
                                      vertical-align: inherit;
                                      font-size: 14px;
                                      color: #000;
                                      font-weight: 400;
                                    "
                                  >
                                    {{ order.user.mobile_number }}</font
                                  > </font
                                ><br />
                                <font style="vertical-align: inherit">
                                  <font
                                    style="
                                      vertical-align: inherit;
                                      font-size: 14px;
                                      color: #000;
                                      font-weight: 400;
                                    "
                                    >{{ order.user.address }}</font
                                  > </font
                                ><br />
                              </td>
                              <td
                                style="
                                  padding: 5px;
                                  vertical-align: top;
                                  text-align: left;
                                  padding-bottom: 20px;
                                "
                              >
                                <font
                                  style="
                                    vertical-align: inherit;
                                    margin-bottom: 25px;
                                  "
                                >
                                  <font
                                    style="
                                      vertical-align: inherit;
                                      font-size: 14px;
                                      color: #7367f0;
                                      font-weight: 600;
                                      line-height: 35px;
                                    "
                                    >Invoice Info</font
                                  > </font
                                ><br />
                                <font style="vertical-align: inherit">
                                  <font
                                    style="
                                      vertical-align: inherit;
                                      font-size: 14px;
                                      color: #000;
                                      font-weight: 400;
                                    "
                                  >
                                    Reference
                                  </font> </font
                                ><br />
                                <font
                                  style="vertical-align: inherit"
                                  v-if="order.payment_date"
                                >
                                  <font
                                    style="
                                      vertical-align: inherit;
                                      font-size: 14px;
                                      color: #000;
                                      font-weight: 400;
                                    "
                                  >
                                    Payment Date </font
                                  ><br />
                                </font>
                                <font style="vertical-align: inherit">
                                  <font
                                    style="
                                      vertical-align: inherit;
                                      font-size: 14px;
                                      color: #000;
                                      font-weight: 400;
                                    "
                                  >
                                    Payment Status</font
                                  > </font
                                ><br />
                                <font style="vertical-align: inherit">
                                  <font
                                    style="
                                      vertical-align: inherit;
                                      font-size: 14px;
                                      color: #000;
                                      font-weight: 400;
                                    "
                                  >
                                    Status</font
                                  > </font
                                ><br />
                              </td>
                              <td
                                style="
                                  padding: 5px;
                                  vertical-align: top;
                                  text-align: right;
                                  padding-bottom: 20px;
                                "
                              >
                                <font
                                  style="
                                    vertical-align: inherit;
                                    margin-bottom: 25px;
                                  "
                                >
                                  <font
                                    style="
                                      vertical-align: inherit;
                                      font-size: 14px;
                                      color: #7367f0;
                                      font-weight: 600;
                                      line-height: 35px;
                                    "
                                    >&nbsp;</font
                                  > </font
                                ><br />
                                <font style="vertical-align: inherit">
                                  <font
                                    style="
                                      vertical-align: inherit;
                                      font-size: 14px;
                                      color: #000;
                                      font-weight: 400;
                                    "
                                    >{{ order.reference }}
                                  </font> </font
                                ><br />
                                <font
                                  style="vertical-align: inherit"
                                  v-if="order.payment_date"
                                >
                                  <font
                                    style="
                                      vertical-align: inherit;
                                      font-size: 14px;
                                      color: #000;
                                      font-weight: 400;
                                    "
                                    >{{
                                      order.payment_date
                                        ? formatTimeStamp(
                                            order.payment_date,
                                            false
                                          )
                                        : "---"
                                    }} </font
                                  ><br />
                                </font>
                                <font style="vertical-align: inherit">
                                  <font
                                    style="
                                      vertical-align: inherit;
                                      font-size: 14px;
                                      color: #2e7d32;
                                      font-weight: 400;
                                    "
                                  >
                                    {{ order.payment_status }}
                                    <span v-if="order.due > 0">
                                      ({{ this.formatAmount(order.due) }})
                                    </span>
                                  </font>
                                </font>
                                <br />
                                <font style="vertical-align: inherit">
                                  <font
                                    style="
                                      vertical-align: inherit;
                                      font-size: 14px;
                                      color: #2e7d32;
                                      font-weight: 400;
                                    "
                                  >
                                    {{ order.status }}</font
                                  > </font
                                ><br />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr class="heading" style="background: #f3f2f7">
                      <td
                        style="
                          padding: 5px;
                          vertical-align: middle;
                          font-weight: 600;
                          color: #5e5873;
                          font-size: 14px;
                          padding: 10px;
                        "
                      >
                        Product Name
                      </td>
                      <td
                        style="
                          padding: 5px;
                          vertical-align: middle;
                          font-weight: 600;
                          color: #5e5873;
                          font-size: 14px;
                          padding: 10px;
                        "
                      >
                        Ordered Qty
                      </td>
                      <td
                        style="
                          padding: 5px;
                          vertical-align: middle;
                          font-weight: 600;
                          color: #5e5873;
                          font-size: 14px;
                          padding: 10px;
                        "
                      >
                        Paid Qty
                      </td>
                      <td
                        style="
                          padding: 5px;
                          vertical-align: middle;
                          font-weight: 600;
                          color: #5e5873;
                          font-size: 14px;
                          padding: 10px;
                        "
                      >
                        Returned QTY
                      </td>
                      <td
                        style="
                          padding: 5px;
                          vertical-align: middle;
                          font-weight: 600;
                          color: #5e5873;
                          font-size: 14px;
                          padding: 10px;
                        "
                      >
                        Price
                      </td>
                      <td
                        style="
                          padding: 5px;
                          vertical-align: middle;
                          font-weight: 600;
                          color: #5e5873;
                          font-size: 14px;
                          padding: 10px;
                          cursor: help;
                        "
                        title="This is the value per individual crate"
                      >
                        <!-- Crate Value <span style="font-size: 13px; color: #888;">(Per Crate)</span>
                        Crate Value <span style="font-size: 13px; color: #5e5873; font-weight: 500;">(Per Crate)</span> -->
                        Crate Value
                        <span
                          style="
                            cursor: help;
                            font-size: 12px;
                            font-style: italic;
                            color: #6e6b7b;
                          "
                          title="This is the value per individual crate"
                          >(Per Unit)</span
                        >
                        <!-- Crate Value
                        <span
                          title="This is the value per individual crate"
                          style="cursor: help; color: #7367f0"
                          >(?)</span
                        > -->
                      </td>
                      <!-- <td
                        style="
                          padding: 5px;
                          vertical-align: middle;
                          font-weight: 600;
                          color: #5e5873;
                          font-size: 14px;
                          padding: 10px;
                        "
                      >
                        Discount
                      </td>
                      <td
                        style="
                          padding: 5px;
                          vertical-align: middle;
                          font-weight: 600;
                          color: #5e5873;
                          font-size: 14px;
                          padding: 10px;
                        "
                      >
                        TAX
                      </td> -->
                      <td
                        style="
                          padding: 5px;
                          vertical-align: middle;
                          font-weight: 600;
                          color: #5e5873;
                          font-size: 14px;
                          padding: 10px;
                        "
                      >
                        Payment Status
                      </td>
                      <td
                        style="
                          padding: 5px;
                          vertical-align: middle;
                          font-weight: 600;
                          color: #5e5873;
                          font-size: 14px;
                          padding: 10px;
                        "
                      >
                        Subtotal
                      </td>
                      <td
                        style="
                          padding: 5px;
                          vertical-align: middle;
                          font-weight: 600;
                          color: #5e5873;
                          font-size: 14px;
                          padding: 10px;
                        "
                      ></td>
                    </tr>

                    <tr
                      v-for="product in order.products"
                      :key="product.id"
                      class="details"
                      style="border-bottom: 1px solid #e9ecef"
                    >
                      <td
                        style="
                          padding: 10px;
                          vertical-align: top;
                          display: flex;
                          align-items: center;
                        "
                      >
                        <!-- <img
                          :src="product.image"
                          alt="img"
                          class="me-2"
                          style="width: 40px; height: 40px"
                        /> -->
                        {{ product.name }}
                      </td>
                      <td style="padding: 10px; vertical-align: top">
                        {{ product.ordered_qty }}
                      </td>
                      <td style="padding: 10px; vertical-align: top">
                        {{ product.qty_paid }}
                      </td>
                      <td style="padding: 10px; vertical-align: top">
                        {{ product.returned_qty }}
                      </td>
                      <td style="padding: 10px; vertical-align: top">
                        {{ formatAmount(product.price) }}
                      </td>
                      <td style="padding: 10px; vertical-align: top">
                        {{ formatAmount(product.unit_value) }}
                      </td>
                      <!-- <td style="padding: 10px; vertical-align: top">
                        {{ formatAmount(product.discount) }}
                      </td>
                      <td style="padding: 10px; vertical-align: top">
                        {{ formatAmount(product.tax) }}
                      </td> -->
                      <td style="padding: 10px; vertical-align: top">
                        {{ product.payment_status }}
                      </td>
                      <td style="padding: 10px; vertical-align: top">
                        {{ formatAmount(product.sub_total) }}
                      </td>
                      <td
                        style="padding: 10px; vertical-align: top"
                        v-if="
                          product.total_payment &&
                          product.payment_status != 'Complete'
                        "
                      >
                        <div style="display: flex; gap: 8px">
                          <button
                            style="
                              background-color: #ff9f43;
                              border: none;
                              color: white;
                              padding: 8px 16px;
                              text-align: center;
                              font-size: 14px;
                              border-radius: 5px;
                              cursor: pointer;
                              transition: background-color 0.3s ease;
                            "
                            @click="openPaymentModal(product)"
                          >
                            Pay
                          </button>

                          <button
                            style="
                              background-color: #ea5455;
                              border: none;
                              color: white;
                              padding: 8px 16px;
                              text-align: center;
                              font-size: 14px;
                              border-radius: 5px;
                              cursor: pointer;
                              transition: background-color 0.3s ease;
                            "
                            v-if="hasAccess('create-sales-return')"
                            @click="openReturnModal(product)"
                          >
                            Return
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="row">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="total-order w-100 max-widthauto m-auto mb-4">
                      <ul>
                        <li>
                          <h4>Order Tax</h4>
                          <h5>₦ {{ order.tax }}</h5>
                        </li>
                        <li>
                          <h4>Discount</h4>
                          <h5>₦ {{ order.discount }}</h5>
                        </li>
                        <li>
                          <h4>Promo Amount</h4>
                          <h5>₦ {{ 0 }}</h5>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="total-order w-100 max-widthauto m-auto mb-4">
                      <ul>
                        <li>
                          <h4>Shipping</h4>
                          <h5>₦ {{ order.shipping }}</h5>
                        </li>
                        <li>
                          <h4>Amount Paid</h4>
                          <h5>₦ {{ order.paid }}</h5>
                        </li>
                        <li class="total">
                          <h4>Grand Total</h4>
                          <h5>₦ {{ order.total }}</h5>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!------ ORDER PAYMENT START---------->
        <f-table
          v-if="order.payments"
          :filters="['amount', 'reference']"
          :columns="paymentColumns"
          :data="orderPayments"
        >
          <template #top>
            <div class="card-sales-split">
              <h2>Order Payments</h2>
            </div>
          </template>
          <template #bodyCell="{ column, record }">
            <template v-if="column.key == 'paid_by'">
              <router-link
                v-if="record.paid_by.id"
                title="Click to View Admin"
                :to="'admin/' + record.paid_by.id"
                >{{ record.paid_by.name }}</router-link
              >
              <a href="javaScript:void(0)" v-else>
                {{ record.paid_by.name }}
              </a>
            </template>
          </template>
        </f-table>
        <!------ ORDER PAYMENT END---------->
        <!------ PAYMENT RECEIPTS START---------->
        <div class="card" v-if="order.receipts">
          <div class="card-body">
            <div class="card-sales-split">
              <h2>Payment Receipts</h2>
            </div>

            <div class="d-flex">
              <a
                v-for="(image, index) in order.receipts"
                :key="index"
                title="Click to View Image"
                target="_blank"
                :href="image.url"
                class="receipt"
              >
                <img :src="image.url" />
                <caption class="caption">
                  Date:
                  {{
                    image.date
                  }}
                </caption>
              </a>
            </div>
          </div>
        </div>
        <!------ PAYMENT RECEIPTS END---------->
      </div>
    </div>

    <!------ Pay Modal ---------->
    <div
      class="modal fade"
      id="payOrderProduct"
      tabindex="-1"
      aria-labelledby="payOrderProduct"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Pay for Order Product</h5>
            <button
              type="button"
              class="close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div class="modal-body">
            <div v-if="selectedOrderProduct">
              <div class="form-group">
                <label>Quantity to Pay For</label>
                <input
                  type="number"
                  min="1"
                  :max="remainingQty"
                  v-model.number="quantityToPay"
                  class="form-control"
                  placeholder="Enter quantity"
                />
                <small class="text-muted d-block mt-1">
                  Remaining to pay: {{ remainingQty }} unit(s)
                </small>
              </div>

              <div class="form-group mt-3">
                <label>Note (optional)</label>
                <a-textarea
                  v-model:value="paymentNote"
                  show-count
                  :maxlength="50"
                  placeholder="e.g. Partial payment from balance"
                />
              </div>

              <div class="summary mt-4">
                <b>Summary</b>
                <p>
                  {{ quantityToPay }} unit(s) × ₦{{ unitAmount }} =
                  <b>₦{{ quantityToPay * unitAmount }}</b>
                </p>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              class="btn btn-submit"
              @click="submitPayment"
              :disabled="loading"
            >
              <template v-if="!loading">
                <span id="btntext">Submit</span>
              </template>
              <template v-else>
                <i class="fas fa-spinner fa-spin me-2"></i> Submitting...
              </template>
            </button>

            <button
              class="btn btn-cancel"
              @click="closePaymentModal"
              :disabled="loading"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>

    <!------ End Pay Modal ---------->
    <ReturnModal
      :selectedOrderProduct="selectedReturnProduct"
      :order_ref="order.reference"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ReturnModal from "@/views/pages/sales/modals/order-product-return-modal.vue";
import { _sale } from "@/store/models";
import html2pdf from "html2pdf.js";
import store from "@/store";
import { formatTimeStamp } from "../../../helpers";
// import {formatTimeStamp} from "@/helpers"

const paymentColumns = [
  {
    title: "Amount",
    dataIndex: "amount",
    sorter: (a, b) => a.date.localeCompare(b.date),
  },
  {
    title: "Reference",
    dataIndex: "reference",
    sorter: (a, b) => a.reference.localeCompare(b.reference),
  },
  {
    title: "Payment Method",
    dataIndex: "method",
    sorter: (a, b) => a.method.localeCompare(b.method),
  },
  {
    title: "Paid By",
    key: "paid_by",
  },
  {
    title: "Date",
    dataIndex: "date",
    sorter: (a, b) => a.date.localeCompare(b.date),
  },
];
export default {
  components: {
    ReturnModal,
  },
  data() {
    return {
      showReturnModal: false,
      selectedReturnProduct: {},
      formatTimeStamp,
      title: "Order Detail",
      title1: "View Order details",
      order: _sale,
      paymentColumns,
      orderFetched: false,
      Status: ["Choose Status", "Completed", "Inprogress"],
      orderPayments: [],
      selectedOrderProduct: null, // object: set when opening modal
      quantityToPay: 1,
      paymentNote: null,
      unitAmount: 0,
      remainingQty: 0,
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      formatAmount: "formatAmount",
      hasAccess: "hasAccess",
    }),
  },
  methods: {
    ...mapActions({
      _getOrderDetail: "orders/show",
      _submitPayment: "orders/submitOrderProductPayment",
    }),
    exportToPdf() {
      html2pdf(document.getElementById("order-detail"), {
        margin: 5,
        filename: this.order.reference + ".pdf",
        enableLinks: true,

        image: {
          type: "png",
          quality: 50.98,
        },
      });
    },
    exportToPosPdf() {
      store.dispatch("print/printOrderReceipt", this.order.id);
    },

    getOrderDetail() {
      let id = this.$route.params.id;
      this._getOrderDetail({ order_id: id }).then((response) => {
        this.order = response.data.data;
        if (this.order.payments) {
          this.orderPayments = this.order.payments.map((payment) => {
            payment.amount = `₦ ${payment.amount}`; // Add Naira Sign
            return payment;
          });
        }
        this.orderFetched = true;
      });
    },

    openPaymentModal(orderProduct) {
      this.selectedOrderProduct = orderProduct;
      this.unitAmount =
        Number(orderProduct.unit_value || 0) + Number(orderProduct.price || 0);

      const totalPaid = Number(orderProduct.total_payment ?? 0);
      this.remainingQty =
        orderProduct.quantity - Math.floor(totalPaid / this.unitAmount);

      this.quantityToPay = 1;
      this.paymentNote = "";
      $("#payOrderProduct").modal("show");
    },

    closePaymentModal() {
      $("#payOrderProduct").modal("hide");
    },

    async submitPayment() {
      const qty = Number(this.quantityToPay);

      if (qty < 1 || qty > this.remainingQty) {
        alert(`Please enter a quantity between 1 and ${this.remainingQty}`);
        return;
      }

      const payload = [
        {
          order_product_id: this.selectedOrderProduct.order_product_id,
          qty,
        },
      ];

      this.loading = true;

      try {
        await this._submitPayment({ payload });

        await this.getOrderDetail(); // refresh order info
        this.closePaymentModal();
        this.$toast?.success("Payment successful");
      } catch (error) {
        console.error("Payment error:", error);
        this.$toast?.error(
            error?.response?.data?.message || "Payment failed. Please try again."
        );
      } finally {
        this.loading = false;
      }
    },

    openReturnModal(product) {
      if (product) {
        this.selectedReturnProduct = product;
        $("#returnOrderProductModal").modal("show");
      }
    },
  },
  mounted() {
    this.getOrderDetail();
  },
  name: "order-details",
};
</script>
